// extracted by mini-css-extract-plugin
var _1 = "logo__v7_Uc";
export { _1 as "logo" }
